import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'Long Tom',
  description: ["he's dead.", '', 'I remount my horse and hurry on my way. maybe I can still save someone.'],
  buttons: [nextAction('Continue', onDone)]
});

const wake = onDone => ({
  title: 'Long Tom',
  description: [
    'this must be one of the villains. the rest must have left this Tom scoundrel behind to die of his consumption',
    'but which boy? is it the one I see in my nightmares? could he be my boy?',
    'the man starts stirring',
    'I unholster my gun and wait to see if he recognizes me.',
    'his eyes open slowly. then grow wide. his mouth opens but all that comes out is a hacking cough',
    "he's scrambling for something in his belt.",
    'probably a gun'
  ],
  buttons: [nextAction('Shoot', () => onDone(end(onDone)))]
});

const search = onDone => ({
  title: 'Long Tom',
  description: [
    'next to it, a letter. ',
    "\"They left me. Said I was slowin' em down too much on account of my cough. They say they'll take the boy there themselves and will wait for me with my cut. If you don't hear from me soon, you get your brothers to track down them fellas and make them give you my share. We didn't kill all those folks just to get nuthin.",
    '',
    'Yours, Tom"'
  ],
  buttons: [nextAction('What boy?', () => onDone(wake(onDone)))]
});

const approach = onDone => ({
  title: 'Long Tom',
  description: [
    'I approach cautiously',
    'a man. half propped against a rock. lanky. head tilted back. sleeping',
    'eager for company I reach to wake him. but something catches my eye among his belongings:',
    'a map',
    "the same one I've been following"
  ],
  buttons: [nextAction('Look around', () => onDone(search(onDone)))]
});

const start = onDone => ({
  title: 'Long Tom',
  description: [
    "it's been many days of riding alone. no sign of people for miles",
    "suddenly - a plume of smoke on the horizon. coming from the direction I'm headed",
    'a dying fire by the side of the road. down to coals.'
  ],
  buttons: [nextAction('Approach', () => onDone(approach(onDone)))]
});

export default start;
